import { Eye as EyeIcon } from 'phosphor-react'

import { colors, sizes } from '@motrix/tokens'

import type { PhosphorIconProps } from './interfaces'

export const Eye = ({
  color = colors.neutral09,
  id,
  size = '4',
  weight = 'regular',
}: PhosphorIconProps) => {
  return <EyeIcon id={id} size={sizes[size]} weight={weight} color={color} />
}
